import { BROWSER_TYPE } from "libs/conf";
import { Toast } from 'antd-mobile'

const isAndroid = BROWSER_TYPE.IsAndroid
const isIOS = BROWSER_TYPE.IsIOS
export let url = {
	open: "",
	down: "https://m.avatr.com/download",
};
if (window.location.host === "planet.stg.avatr.com") {
	url.down = "https://m.stg.avatr.com/download";
}
/**
 * 获取页面隐藏属性的前缀
 * 如果页面支持 hidden 属性，返回 '' 就行
 * 如果不支持，各个浏览器对 hidden 属性，有自己的实现，不同浏览器不同前缀，遍历看支持哪个
 */
function getPagePropertyPrefix() {
	const prefixes = ["webkit", "moz", "ms", "o"];
	let correctPrefix;
	if ("hidden" in document) return "";
	prefixes.forEach((prefix) => {
		if (`${prefix}Hidden` in document) {
			correctPrefix = prefix;
		}
	});
	return correctPrefix || false;
}

/**
 * 判断页面是否隐藏（进入后台）
 */
function isPageHidden() {
	const prefix = getPagePropertyPrefix();
	if (prefix === false) return false;
	const hiddenProperty = prefix ? `${prefix}Hidden` : "hidden";
	// @ts-ignore
	return document[hiddenProperty];
}
/**
 * 获取判断页面 显示|隐藏 状态改变的属性
 */
function getVisibilityChangeProperty() {
	const prefix = getPagePropertyPrefix();
	if (prefix === false) return false;
	return `${prefix}visibilitychange`;
}

/**
 * 检测是否唤端成功
 */
function checkOpen() {
	const visibilityChangeProperty = getVisibilityChangeProperty();
	const timer = setTimeout(() => {
		const hidden = isPageHidden();
		if (!hidden) {
			// 端口唤起失败，跳转下载页面
			if (isIOS) {
				window.location.href = url.down;
			} else if (isAndroid) {
				window.location.href = url.down;
			}
		}
	}, 5000);
	if (visibilityChangeProperty) {
		document.addEventListener(visibilityChangeProperty, (res) => {
			clearTimeout(timer);
		});
		return;
	}
	window.addEventListener("pagehide", () => {
		clearTimeout(timer);
	});
}

const openApp = (path: string) => {
  if(!path){
    Toast.show("appScheme路径未知")
    return
  }
	url.open = path
	if (isAndroid) {
		let iframe = document.createElement("iframe");
		let body = document.body;
		iframe.style.cssText = "display:none;width=0;height=0";

		body.appendChild(iframe);
		iframe.src = url.open;
		checkOpen();
	} else {
		window.location.href = url.open;
		checkOpen();
	}
};

export default openApp;
